import { render } from "./ListeInventaire.vue?vue&type=template&id=0639dbca&ts=true"
import script from "./ListeInventaire.vue?vue&type=script&lang=ts"
export * from "./ListeInventaire.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__